import React from "react";
import PropTypes from "prop-types";
import EditLinkToPill from "../../../../../../CommonComponents/EditLinkToPill/EditLinkToPill";

export const RecommendGrantStep = ({ children, link, analyticsTracking, prefixId }) => {
  const isEditVisible =
    window.location.pathname ===
    "/portal/contributions/make-a-contribution/funding-instructions"
      ? false
      : true;
  return (
    <>
      {children}
      {link && isEditVisible && (
        <EditLinkToPill
          data-test="link-to-pill"
          prefixId={prefixId}
          analyticsTracking={(value) =>
            analyticsTracking && analyticsTracking(value)
          }
          linkPathname={link}
        />
      )}
    </>
  );
};

RecommendGrantStep.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
    PropTypes.elementType,
  ]),
  link: PropTypes.string,
  analyticsTracking: PropTypes.func,
};
